import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Card, CardBody, Row, Col } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import moment from 'moment'
import Select from '../../components/Template/Input/Select'
import defaultColors from '../../constants/ChartsDefaultColors'
import { getMonthlyActivities } from '../../store/ducks/humanResources'
import './dashboard.scss'

function getColor(string) {
  const str = string.split(' ').map(i => i.charAt(0)).join('')
  let sum = 0
  for (let i = 0; str.length > 2 ? i < 2 : i < str.length; i++) {
    sum += str.charCodeAt(i)
  }
  if (sum > 100) sum -= 100

  return defaultColors[sum]
}

class ActivitiesGraph extends Component {
  constructor(props) {
    super(props)
    this.state = {
      month: {
        value: moment().format('MM/YYYY'),
        label: moment().format('MM/YYYY'),
      },
    }
  }

  componentDidMount() {
    const { getMonthlyActivities } = this.props

    getMonthlyActivities()
  }

  render() {
    const { getMonthlyActivitiesIsLoading, monthlyActivities } = this.props.humanResources
    const { month } = this.state

    if (getMonthlyActivitiesIsLoading) {
      return (
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">Distribuição das atividades</h4>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (monthlyActivities) {
      const array = Object.values(monthlyActivities)
      const months = array.map(i => ({
        value: i.mes,
        label: i.mes,
      }))
      const filtered = array.filter(i => i.mes === month.value)
      if (filtered && filtered.length === 1) {
        const activitiesRaw = Object.entries(filtered[0].alocacao)
        const labels = Object.keys(filtered[0].alocacao)
        const colors = labels.map(label => getColor(label))
        const valuesRaw = Object.values(filtered[0].alocacao)
        const values = valuesRaw.map(value => Number((value * 100).toFixed(0)))
        const activities = activitiesRaw.map((activity, index) => ({
          label: activity[0],
          value: activity[1],
          color: colors[index],
        }))

        return (
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h4 className="card-title mb-4">Distribuição das atividades (%)</h4>
                </Col>
                <Col xl={3} lg={4} md={4} sm={4}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={false}
                    placeholder="Mês"
                    options={months}
                    onChange={month => this.setState({ month })}
                    value={month}
                  />
                </Col>
              </Row>

              <div id="donut-chart" className="apex-charts mt-3">
                <ReactApexChart
                  options={{
                    labels,
                    plotOptions: {
                      pie: {
                        donut: {
                          size: '75%',
                        },
                      },
                    },
                    dataLabels: {
                      enabled: false,
                    },
                    legend: {
                      show: false,
                    },
                    colors,
                  }}
                  series={values}
                  type="pie"
                  height="230"
                />
              </div>

              <Row>
                {activities.map(activity => (
                  <Col xs={4} key={activity.label}>
                    <div className="text-center mt-3" title={`${activity.label} (${(activity.value * 100).toFixed(0)}%)`}>
                      <p className="mb-2 text-truncate">
                        <i className="mdi mdi-circle font-size-10 mr-1" style={{ color: activity.color }} />
                        {' '}
                        {activity.label}
                      </p>
                      <h5>{`${(activity.value * 100).toFixed(0)}%`}</h5>
                    </div>
                  </Col>
                ))}
              </Row>
            </CardBody>
          </Card>
        )
      } return null
    }

    return null
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ getMonthlyActivities }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesGraph)
